<template>
    <div class="intro">
        <h1 class="quiz__title">Skincare Consultation</h1>

        <div class="intro__contents">
            <div class="intro__bottles">
                <img :src="contentAssetPath('images/intro-bottles.jpg')">
            </div>

            <div class="intro__copy-cta">
                <div class="intro__copy">
                    <h1>Hello, let us help you find<br class="dn-sm"> your best skincare regimen.</h1>
                    <p>For every individual skin type and skin concern, there is an ideal skincare regimen — one that helps the skin achieve its own ideal balance for a clear, radiant, youthful complexion. With just a few questions, we will create a skincare regimen that is just right for you.</p>
                </div>

                <div class="select-group">
                    <label for="age">Age</label>
                    <select name="Age" id="age" title="Choose your age" v-model="selected_age">
                        <option :value="null">Please choose an age range.</option>
                        <option v-for="(age,i) in age_options" :value="i" :key="i">{{ age }}</option>
                    </select>
                </div>

                <div class="select-group">
                    <label for="sex">Gender</label>
                    <select name="Age" id="sex" title="Choose your age" v-model="selected_gender">
                        <option :value="null">Please choose your gender.</option>
                        <option v-for="(gender,i) in gender_options" :value="i" :key="i">{{ gender }}</option>
                        <option :value="0">N/A</option>
                    </select>
                </div>

                <div class="intro__ctas">
                    <button class="quiz__nav-btn --start" :class="{ '--enabled': user_can_proceed }" @click="start_quiz">START</button>
                    <a class="link" @click="view_previous_results" v-show="user_has_previous_results">SEE PREVIOUS RESULTS</a>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { bus, cookie_key, contentAssetPath } from '../../utilities/index'
    import logic from '../../data/logic'

    export default {
        name: 'Introduction',
        data() {
            return {
                gender_options: logic.quiz[0].options,
                age_options: logic.quiz[1].options,
                selected_gender: null,
                selected_age: null
            }
        },
        computed: {
            user_can_proceed() {
                return this.selected_gender !== null && this.selected_age !== null
            },
            user_has_previous_results() {
                return this.$cookie.get(cookie_key)
            }
        },
        methods: {
            start_quiz() {
                if (this.user_can_proceed) {
                    const answers = [
                        this.selected_gender,
                        this.selected_age
                    ].join('/')

                    bus.$emit('next', '/questions/'.concat(answers))
                }
            },
            view_previous_results() {
                bus.$emit('next', this.$cookie.get(cookie_key))
            },
            contentAssetPath
        }
    }
</script>


// WEBPACK FOOTER //
// source/app/js/components/sections/introduction.vue